
import { IDanhGiaKetQuaSelectRequest } from "../../models/request/danh-gia/IDanhGiaKetQuaSelectRequest"
import { IDotDanhGiaKetQuaSubmitRequest } from "../../models/request/danh-gia/IDotDanhGiaKetQuaSubmitRequest"
import { IDotDanhGiaKetQua } from "../../models/response/danh-gia/IDotDanhGiaKetQua"
import { apiClient, formatQueryString } from "../apiClient"

export const DOT_DANH_GIA_KET_QUA = "danh-gia-ket-qua"
export const dotDanhGiaKetQuaApi = {
    Submit: (payload: IDotDanhGiaKetQuaSubmitRequest<IDotDanhGiaKetQua[]>) => apiClient.put(`${DOT_DANH_GIA_KET_QUA}`, payload),
    Select: (request: IDanhGiaKetQuaSelectRequest) => apiClient.get(`${DOT_DANH_GIA_KET_QUA}?${formatQueryString(request)}`),
}